export const NAVBAR_WIDTH = 48;
export const EXPANDED_NAVBAR_WIDTH = 228;
export const NAVBAR_LOGO_WIDTH = 24;
export const EXPANDED_NAVBAR_LOGO_WIDTH = 140;

export const SIZES = {
	NAVBAR_WIDTH,
	EXPANDED_NAVBAR_WIDTH,
	NAVBAR_LOGO_WIDTH,
	EXPANDED_NAVBAR_LOGO_WIDTH,
};
